import { render } from "./CxReferenceModelFilter.vue?vue&type=template&id=60cc7923"
import script from "./CxReferenceModelFilter.vue?vue&type=script&lang=js"
export * from "./CxReferenceModelFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__